import { useContext } from "react";
import { SurveyFormContext } from "@/components/common/resource-survey/components/survey-form/survey-form-context";
import { cn } from "@/lib/utils";
import { Textarea } from "@/components/ui/textarea";

export const SurveyRadio = ({
  payload,
  index,
}: {
  payload: SurveyNodePayloadRadioVM;
  index: number;
}) => {
  const { options } = payload;
  const { setStepsAnswers, stepsAnswers, currentStep } =
    useContext(SurveyFormContext);

  const stepAnswers = stepsAnswers[currentStep];
  const { value, customAnswer } = stepAnswers[index] as {
    value: string;
    customAnswer?: string;
  };

  return (
    <div>
      {options.map((option) => (
        <>
          <div
            key={option.label}
            className={cn(
              "mb-2 flex items-center gap-3 rounded-lg border border-zinc-500 px-2 py-[12.5px] text-sm leading-tight font-normal text-zinc-800 hover:cursor-pointer",
              option.label === value && "border-remedium-blue",
            )}
            onClick={() => {
              setStepsAnswers((draft) => {
                draft[currentStep][index].value = option.label;
                if (option.customAnswer) {
                  draft[currentStep][index].customAnswer = null;
                }
              });
            }}
          >
            <div
              className={cn(
                "flex h-[14px] w-[14px] items-center justify-center rounded-full border border-zinc-500 bg-white",
                option.label === value && "border-remedium-blue",
                "before:block before:h-1.5 before:w-1.5 before:rounded-full before:bg-zinc-50 before:content-['']",
                option.label === value &&
                  "before:border-remedium-blue before:bg-remedium-blue",
              )}
            ></div>
            {option.label}
          </div>

          {option.customAnswer && option.label === value && (
            <>
              <Textarea
                placeholder={"Twoja odpowiedź"}
                onChange={({ target }: { target: HTMLTextAreaElement }) => {
                  setStepsAnswers((draft) => {
                    draft[currentStep][index].customAnswer = target.value;
                  });
                }}
                value={customAnswer}
              />
              <br />
              <br />
            </>
          )}
        </>
      ))}
    </div>
  );
};
